import React, { PropsWithChildren, useMemo } from "react";
import { Platform, ViewStyle } from "react-native";
import { Box, ColorType } from "arkh";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useSizeClass } from "../common/Utils/useSizeClass";
import { SizeClass } from "../common/Utils/SizeClass";

export function useNavigationHeaderHeight() {
  const isCompact = useSizeClass().width === SizeClass.COMPACT;
  return useMemo(
    () => (Platform.OS === "android" ? 56 : isCompact ? 44 : 50),
    [isCompact]
  );
}

export function AHNavigationHeaderContainer(
  props: PropsWithChildren<{
    color?: ColorType;
    borderColor?: ColorType;
    style?: ViewStyle;
  }>
) {
  const topInset = useSafeAreaInsets().top;
  const headerHeight = useNavigationHeaderHeight();
  return (
    <Box
      color={props.color ?? "transparent"}
      borderColor={props.borderColor ?? "transparent"}
      style={[
        {
          height: headerHeight + topInset,
          paddingTop: topInset,
          borderBottomWidth: 1,
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
        },
        props.style,
      ]}
    >
      {props.children}
    </Box>
  );
}
